import { ingestionBadgeFor, SessionBadges } from "@/shared/components/sessions";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks";
import { type SessionRecord } from "@/shared/domain/sessions";
import {
  useIsSessionComplete,
  useSessionIngestionStatus,
} from "@/shared/domain/sessions/hooks";

import { ingestionSummary } from "./sessionIngestion";

/**
 * The session page's status and ingestion badges, the same ones the sessions
 * list shows (see {@link SessionBadges}). Hidden in orgs without session
 * ingestion, where no session can be marked complete. Unlike the list, the
 * page shows "In progress" even for a session nobody opted into completion,
 * since it sits beside the Mark complete button that ends that state.
 */
export function SessionStatusBadge({ session }: { session: SessionRecord }) {
  const released = useCheckFeatureFlag(
    "release-session-ingestion",
    session.org_id,
  );
  const showsInProgress = released;
  const status = useSessionIngestionStatus({
    session,
    enabled: session.status === "complete" || showsInProgress,
  });
  const complete = useIsSessionComplete(session, status);
  if (!complete && !showsInProgress) {
    return null;
  }
  const summary =
    status.data === undefined ? undefined : ingestionSummary(status.data);
  return (
    <SessionBadges
      session={session}
      complete={complete}
      ingestion={ingestionBadgeFor(complete, summary, {
        failed: status.isError,
      })}
      counts={summary}
    />
  );
}
